module.exports = __webpack_public_path__ + "static/img/1-50.7c1ad96.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/1-50.png
// module id = Czc7
// module chunks = 15